const SECONDARY_VIEWS = {
    NEW_PRODUCT: "NEW_PRODUCT",
    EDIT_PRODUCT: "EDIT_PRODUCT",
};

export const PRODUCTS_MODULE_UI_CONSTANTS = {
    SECONDARY_VIEWS,
};